"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedResponse = void 0;
const utils_1 = require("../utils");
class CachedResponse {
    response;
    lastUpdate = BigInt(0);
    duration;
    constructor(duration) {
        this.duration = duration;
    }
    async rpcCall(client, endpoint, request, forceUpdate = false) {
        const update = this.shouldUpdate();
        if (!update && !forceUpdate && this.response !== undefined) {
            return this.response;
        }
        const response = await client.rpcCall(endpoint, request);
        this.response = response.result;
        return response.result;
    }
    shouldUpdate() {
        // no duration set never update
        if (this.duration === undefined) {
            return false;
        }
        const currentTime = utils_1.TimeUtils.now();
        const update = currentTime >= this.lastUpdate + this.duration;
        if (update) {
            this.lastUpdate = currentTime;
        }
        return update;
    }
}
exports.CachedResponse = CachedResponse;
